var Item = Backbone.Model.extend({
    defaults: {
        'visible' : true
    }
});

export {Item};